import Link from 'next/link';
import Image from 'next/image';
import { HiCheckCircle, HiStar } from 'react-icons/hi';
import { testsCategoryUrl } from 'src/services/route-utils';

type Props = {
    renderFor: 'mobile' | 'desktop';
};

export default function NoTestsBanner({ renderFor }: Props) {
    return (
        <div className="">
            <h2 className="text-xl">
                Pentru o experiență completă, îți recomandăm să selectezi analizele pentru care dorești să te
                programezi. De ce?
            </h2>
            <ul className="my-4 text-sm">
                <li className="my-1">
                    <HiCheckCircle className="text-primary mr-2 inline-block text-xl" />
                    Afli prețul analizelor direct din stadiul programării.
                </li>
                <li className="my-1">
                    <HiCheckCircle className="text-primary mr-2 inline-block text-xl" />
                    Te asiguri că analizele pe care le dorești se efectuează în locația preferată de tine.
                </li>
                <li className="my-1">
                    <HiStar className="text-blue mr-2 inline-block text-xl" />
                    Lista de analize adăugate e orientativă. Vei mai putea face modificări înainte de recoltare, la
                    recepție.
                </li>
            </ul>
            <Link href={testsCategoryUrl(null)} className="btn btn-secondary mt-8 block text-sm">
                Mergi la pagina de Analize
            </Link>
            {renderFor === 'mobile' ? (
                <div className="my-4 text-center text-sm">Sau continuă mai jos cu programarea online.</div>
            ) : (
                <Image
                    src="/images/appointments/no-tests.png"
                    priority
                    alt="Programare fără analize selectate"
                    width="356"
                    height="234"
                    className="mx-auto my-4"
                />
            )}
        </div>
    );
}
